module.exports = __webpack_public_path__ + "static/media/shotsTotalSidebar.563d5593.png";